import { call, put, takeEvery } from "redux-saga/effects";
import { types } from "../action-types";
import {deleteJobApi} from "../../API/API";

function* deleteJobSaga(params) {
  try {
    const response = yield call(deleteJobApi, params);
    yield put({
      type: types.DELETE_JOB_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({ type: types.DELETE_JOB_FAILURE, error });
  }
}

export function* watchdeleteJobSaga() {
  yield takeEvery(types.DELETE_JOB_REQUESTED, deleteJobSaga);
}